import { AfterViewInit, Component, OnInit } from '@angular/core';
import { takeUntil } from 'rxjs';

import { ScriptLoader, WindowRef } from '@spartacus/core';

import { AbstractComponent } from '../abstract-component.component';
import { UberallInterface } from '../../../models';

@Component({
  selector: 'wc-uberall-cms',
  templateUrl: './uberall-cms.component.html',
  standalone: true
})
export class UberallCMSComponent extends AbstractComponent<UberallInterface> implements OnInit, AfterViewInit {
  readonly SCRIPT: string = 'https://uberall.com/assets/storeFinderWidget-v2.js';

  key: string;
  baseUrl: string;

  constructor(
    private windowRef: WindowRef,
    private scriptLoader: ScriptLoader
  ) {
    super();
  }

  ngOnInit(): void {
    this.component$.pipe(takeUntil(this.destroy$)).subscribe((component: UberallInterface) => {
      if (component?.dataKey) {
        this.key = component.dataKey;
        this.baseUrl = component.baseUrl;

        this.scriptLoader.embedScript({
          src: this.SCRIPT,
          callback: () => this.windowRef.nativeWindow['UberallStorefinderStart']?.()
        });
      }
      this.setLoaded();
    });
  }

  ngAfterViewInit(): void {
    if (this.windowRef.isBrowser()) {
      this.windowRef.nativeWindow['UberallStorefinderMount']?.();
    }
  }
}
